var map = {
	"./about-card.de-CH.json": 1282,
	"./about-card.de-DE.json": 1283,
	"./about-card.en-CA.json": 1284,
	"./about-card.en-GB.json": 1285,
	"./about-card.en-IN.json": 1286,
	"./about-card.en-ME.json": 1287,
	"./about-card.en-US.json": 1288,
	"./about-card.es-EM.json": 1289,
	"./about-card.es-ES.json": 1290,
	"./about-card.fr-BE.json": 1291,
	"./about-card.fr-CA.json": 1292,
	"./about-card.fr-CH.json": 1293,
	"./about-card.nl-BE.json": 1294,
	"./about-card.nl-NL.json": 1295,
	"./about-card.pl-PL.json": 1296,
	"./about-card.pt-BR.json": 1297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1281;